import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=790d6641&scoped=true&"
import script from "./dict.vue?vue&type=script&lang=ts&"
export * from "./dict.vue?vue&type=script&lang=ts&"
import style0 from "./dict.vue?vue&type=style&index=0&id=790d6641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d6641",
  null
  
)

export default component.exports